import React, { useEffect, useState } from 'react'; 
import { curationApiUrl} from "../config/default";

import "../css/image-browser-table.css";


export default function ImageGallery() {

    const [loading, setLoading] = React.useState(false);

    const [imageData, setImageData] = useState<any>([]);
    

    //first thing done: update page title
    useEffect(() => {
        document.title = 'Image Gallery - Vista Enhancer Browser'; 
    }, []);


    const keepTopPerExperiment = (initImageData:any[]) => {

        var exp_hier_codes: string[] = [];
        var unique_first_images:any[] = [];
        initImageData.forEach(function(item:any){
            if(!exp_hier_codes.includes(item.metadata.exp_hier)) {
                if(item.metadata.image === 1 && item.metadata.exp_embryo === 1) {
                    unique_first_images.push(item.metadata);
                    exp_hier_codes.push(item.metadata.exp_hier);
                }
            }
        });
       return(unique_first_images);
    };

    const loadImageData = () => {
        const imageApiUrl = curationApiUrl + "/EmbryoImages/externalImages";
        setLoading(true);
        fetch(imageApiUrl)
        .then(res => res.json())
        .then(
            (result) => {
                
                    var filteredImageData = keepTopPerExperiment(result.data);
                    // var exp_hiers: string[] = [];
                    // filteredImageData.forEach(function(item:any){
                    //     exp_hiers.push(item.exp_hier);
                    // });
                    // var experimentsUrl = apiUrl + "/catalogs/externalElementPage?exp_hier=" + exp_hiers.join(",");

                    // fetch(experimentsUrl).then(res => res.json()).then(
                    //     (dataResult) => {

                    //     }
                    // )

                    setLoading(false);
                    setImageData(filteredImageData);
                  }, 
                  (error) => { 
                setLoading(false);
                console.log("load data failed", error);
              }
            );
    };


        

    
        useEffect(() => {
            loadImageData();
         }, []);

    
         const renderImages = (images:any) =>{
            return images.map((img:any)=>{
                console.log(img)
              let _key = Math.floor(Math.random() * 9999);
              return (
                <div key={img.exp_embryo+_key}> 
                  <img src={img.img_path+"_thumb.png"} 
                        alt={img.name}
                        className='float-left custom-column'
                        width="150"/> 
                </div>
              );
      
            })
          };


          


    return(
        <div className="container">
<h1 className="text-center">
Annotated Structures and Examples
</h1>
<br/><br/>
<h2>	Forebrain	</h2>
				<img  src="https://vista-enhancer.lbl.gov/structure_gallery/forebrain.jpg"/>
			<a className="" href="element?vistaId=hs200"><img className="border mx-2 my-2"src="https://vista-enhancer.lbl.gov/structure_gallery/200_2.jpg"/></a>
			<a className="" href="element?vistaId=hs595"><img className="border mx-2 my-2"src="https://vista-enhancer.lbl.gov/structure_gallery/595_1.jpg"/></a>
			<a className="" href="element?vistaId=hs853"><img className="border mx-2 my-2"src="https://vista-enhancer.lbl.gov/structure_gallery/853_1.jpg"/></a>
			<a className="" href="element?vistaId=hs110"><img className="border mx-2 my-2"src="https://vista-enhancer.lbl.gov/structure_gallery/110_2.jpg"/></a>
			<a className="" href="element?vistaId=hs671"><img className="border mx-2 my-2"src="https://vista-enhancer.lbl.gov/structure_gallery/671_4.jpg"/></a>
			<a className="" href="element?vistaId=hs411"><img className="border mx-2 my-2"src="https://vista-enhancer.lbl.gov/structure_gallery/411_1.jpg"/></a>
			<a className="" href="element?vistaId=hs611"><img className="border mx-2 my-2"src="https://vista-enhancer.lbl.gov/structure_gallery/611_3.jpg"/></a>
			<a className="" href="element?vistaId=hs692"><img className="border mx-2 my-2"src="https://vista-enhancer.lbl.gov/structure_gallery/692_1.jpg"/></a>
			<a className="" href="element?vistaId=hs840"><img className="border mx-2 my-2"src="https://vista-enhancer.lbl.gov/structure_gallery/840_3.jpg"/></a>
			<a className="" href="element?vistaId=hs742"><img className="border mx-2 my-2"src="https://vista-enhancer.lbl.gov/structure_gallery/742_1.jpg"/></a>
			<a className="" href="element?vistaId=hs798"><img className="border mx-2 my-2"src="https://vista-enhancer.lbl.gov/structure_gallery/798_1.jpg"/></a>
			<a className="" href="element?vistaId=hs702"><img className="border mx-2 my-2"src="https://vista-enhancer.lbl.gov/structure_gallery/702_1.jpg"/></a>
			<a className="" href="element?vistaId=hs565"><img className="border mx-2 my-2"src="https://vista-enhancer.lbl.gov/structure_gallery/565_1.jpg"/></a>
<br/><hr/><br/>
<h2>	Midbrain	</h2>
				<img  src="https://vista-enhancer.lbl.gov/structure_gallery/midbrain.jpg"/>

			<a className="" href="element?vistaId=hs699"><img className="border mx-2 my-2"src="https://vista-enhancer.lbl.gov/structure_gallery/699_1.jpg"/></a>
			<a className="" href="element?vistaId=hs654"><img className="border mx-2 my-2"src="https://vista-enhancer.lbl.gov/structure_gallery/654_1.jpg"/></a>
			<a className="" href="element?vistaId=hs865"><img className="border mx-2 my-2"src="https://vista-enhancer.lbl.gov/structure_gallery/865_3.jpg"/></a>
			<a className="" href="element?vistaId=hs830"><img className="border mx-2 my-2"src="https://vista-enhancer.lbl.gov/structure_gallery/830_2.jpg"/></a>
			<a className="" href="element?vistaId=hs755"><img className="border mx-2 my-2"src="https://vista-enhancer.lbl.gov/structure_gallery/755_2.jpg"/></a>
            <br/><hr/><br/>

<h2>	Hindbrain	</h2>
				<img  src="https://vista-enhancer.lbl.gov/structure_gallery/hindbrain.jpg"/>

			<a className="" href="element?vistaId=hs282"><img className="border mx-2 my-2"src="https://vista-enhancer.lbl.gov/structure_gallery/282_1.jpg"/></a>
			<a className="" href="element?vistaId=hs369"><img className="border mx-2 my-2"src="https://vista-enhancer.lbl.gov/structure_gallery/369_1.jpg"/></a>
			<a className="" href="element?vistaId=hs327"><img className="border mx-2 my-2"src="https://vista-enhancer.lbl.gov/structure_gallery/327_1.jpg"/></a>
			<a className="" href="element?vistaId=hs1020"><img className="border mx-2 my-2"src="https://vista-enhancer.lbl.gov/structure_gallery/1020_1.jpg"/></a>
			<a className="" href="element?vistaId=hs191"><img className="border mx-2 my-2"src="https://vista-enhancer.lbl.gov/structure_gallery/191_1.jpg"/></a>
			<a className="" href="element?vistaId=hs161"><img className="border mx-2 my-2"src="https://vista-enhancer.lbl.gov/structure_gallery/161_1.jpg"/></a>
            <br/><hr/><br/>

<h2>	Neural Tube	</h2>
				<img  src="https://vista-enhancer.lbl.gov/structure_gallery/neuraltube.jpg"/>

			<a className="" href="element?vistaId=hs1043"><img className="border mx-2 my-2"src="https://vista-enhancer.lbl.gov/structure_gallery/1043_2.jpg"/></a>
			<a className="" href="element?vistaId=hs238"><img className="border mx-2 my-2"src="https://vista-enhancer.lbl.gov/structure_gallery/238_1.jpg"/></a>
			<a className="" href="element?vistaId=hs169"><img className="border mx-2 my-2"src="https://vista-enhancer.lbl.gov/structure_gallery/169_1.jpg"/></a>
			<a className="" href="element?vistaId=hs230"><img className="border mx-2 my-2"src="https://vista-enhancer.lbl.gov/structure_gallery/230_4.jpg"/></a>
			<a className="" href="element?vistaId=hs311"><img className="border mx-2 my-2"src="https://vista-enhancer.lbl.gov/structure_gallery/311_1.jpg"/></a>
			<a className="" href="element?vistaId=hs769"><img className="border mx-2 my-2"src="https://vista-enhancer.lbl.gov/structure_gallery/769_2.jpg"/></a>
            <br/><hr/><br/>

<h2>	Eye	</h2>
				<img  src="https://vista-enhancer.lbl.gov/structure_gallery/eye.jpg"/>

			<a className="" href="element?vistaId=hs157"><img className="border mx-2 my-2"src="https://vista-enhancer.lbl.gov/structure_gallery/157_1.jpg"/></a>
			<a className="" href="element?vistaId=hs381"><img className="border mx-2 my-2"src="https://vista-enhancer.lbl.gov/structure_gallery/381_2.jpg"/></a>
			<a className="" href="element?vistaId=hs234"><img className="border mx-2 my-2"src="https://vista-enhancer.lbl.gov/structure_gallery/234_1.jpg"/></a>
			<a className="" href="element?vistaId=hs381"><img className="border mx-2 my-2"src="https://vista-enhancer.lbl.gov/structure_gallery/381_2.jpg"/></a>
            <br/><hr/><br/>


<h2>	Ear	</h2>
				<img  src="https://vista-enhancer.lbl.gov/structure_gallery/ear.jpg"/>

			<a className="" href="element?vistaId=hs579"><img className="border mx-2 my-2"src="https://vista-enhancer.lbl.gov/structure_gallery/579_1.jpg"/></a>
			<a className="" href="element?vistaId=hs543"><img className="border mx-2 my-2"src="https://vista-enhancer.lbl.gov/structure_gallery/543_2.jpg"/></a>
            <br/><hr/><br/>

<h2>	Dorsal Root Ganglia	</h2>
				<img  src="https://vista-enhancer.lbl.gov/structure_gallery/drg.jpg"/>

			<a className="" href="element?vistaId=hs51"><img className="border mx-2 my-2"src="https://vista-enhancer.lbl.gov/structure_gallery/51_1.jpg"/></a>
			<a className="" href="element?vistaId=hs421"><img className="border mx-2 my-2"src="https://vista-enhancer.lbl.gov/structure_gallery/421_1.jpg"/></a>
            <br/><hr/><br/>

<h2>	Trigeminal	</h2>
				<img  src="https://vista-enhancer.lbl.gov/structure_gallery/trigeminal.jpg"/>

			<a className="" href="element?vistaId=hs385"><img className="border mx-2 my-2"src="https://vista-enhancer.lbl.gov/structure_gallery/385_1.jpg"/></a>
			<a className="" href="element?vistaId=hs382"><img className="border mx-2 my-2"src="https://vista-enhancer.lbl.gov/structure_gallery/382_1.jpg"/></a>
            <br/><hr/><br/>

<h2>	Cranial Nerves	</h2>
				<img  src="https://vista-enhancer.lbl.gov/structure_gallery/cranialnerves.jpg"/>

			<a className="" href="element?vistaId=hs680"><img className="border mx-2 my-2"src="https://vista-enhancer.lbl.gov/structure_gallery/680_3.jpg"/></a>
			<a className="" href="element?vistaId=hs809"><img className="border mx-2 my-2"src="https://vista-enhancer.lbl.gov/structure_gallery/809_1.jpg"/></a>
            <br/><hr/><br/>

<h2>	Heart	</h2>
				<img  src="https://vista-enhancer.lbl.gov/structure_gallery/heart.jpg"/>

			<a className="" href="element?vistaId=hs222"><img className="border mx-2 my-2"src="https://vista-enhancer.lbl.gov/structure_gallery/222_1.jpg"/></a>
			<a className="" href="element?vistaId=hs229"><img className="border mx-2 my-2"src="https://vista-enhancer.lbl.gov/structure_gallery/229_1.jpg"/></a>
            <br/><hr/><br/>

<h2>	Tail	</h2>
				<img  src="https://vista-enhancer.lbl.gov/structure_gallery/tail.jpg"/>

			<a className="" href="element?vistaId=hs511"><img className="border mx-2 my-2"src="https://vista-enhancer.lbl.gov/structure_gallery/511_1.jpg"/></a>
            <br/><hr/><br/>

<h2>	Limb	</h2>
				<img  src="https://vista-enhancer.lbl.gov/structure_gallery/limb.jpg"/>

			<a className="" href="element?vistaId=hs388"><img className="border mx-2 my-2"src="https://vista-enhancer.lbl.gov/structure_gallery/388_4.jpg"/></a>
			<a className="" href="element?vistaId=hs774"><img className="border mx-2 my-2"src="https://vista-enhancer.lbl.gov/structure_gallery/774_1.jpg"/></a>
			<a className="" href="element?vistaId=hs72"><img className="border mx-2 my-2"src="https://vista-enhancer.lbl.gov/structure_gallery/72_2.jpg"/></a>
			<a className="" href="element?vistaId=hs243"><img className="border mx-2 my-2"src="https://vista-enhancer.lbl.gov/structure_gallery/243_3.jpg"/></a>
			<a className="" href="element?vistaId=hs335"><img className="border mx-2 my-2"src="https://vista-enhancer.lbl.gov/structure_gallery/335_1.jpg"/></a>
			<a className="" href="element?vistaId=hs1109"><img className="border mx-2 my-2"src="https://vista-enhancer.lbl.gov/structure_gallery/1109_1.jpg"/></a>
			<a className="" href="element?vistaId=hs329"><img className="border mx-2 my-2"src="https://vista-enhancer.lbl.gov/structure_gallery/329_2.jpg"/></a>
			<a className="" href="element?vistaId=hs878"><img className="border mx-2 my-2"src="https://vista-enhancer.lbl.gov/structure_gallery/878_1.jpg"/></a>
			<a className="" href="element?vistaId=hs326"><img className="border mx-2 my-2"src="https://vista-enhancer.lbl.gov/structure_gallery/326_1.jpg"/></a>
			<a className="" href="element?vistaId=hs280"><img className="border mx-2 my-2"src="https://vista-enhancer.lbl.gov/structure_gallery/280_1.jpg"/></a>
            <br/><hr/><br/>

<h2>	Nose	</h2>
				<img  src="https://vista-enhancer.lbl.gov/structure_gallery/nose.jpg"/>

			<a className="" href="element?vistaId=hs248"><img className="border mx-2 my-2"src="https://vista-enhancer.lbl.gov/structure_gallery/248_1.jpg"/></a>
			<a className="" href="element?vistaId=hs586"><img className="border mx-2 my-2"src="https://vista-enhancer.lbl.gov/structure_gallery/586_1.jpg"/></a>
			<a className="" href="element?vistaId=hs422"><img className="border mx-2 my-2"src="https://vista-enhancer.lbl.gov/structure_gallery/422_1.jpg"/></a>
            <br/><hr/><br/>

<h2>	Face	</h2>
				<img  src="https://vista-enhancer.lbl.gov/structure_gallery/face.jpg"/>

			<a className="" href="element?vistaId=hs836"><img className="border mx-2 my-2"src="https://vista-enhancer.lbl.gov/structure_gallery/836_1.jpg"/></a>
            <br/><hr/><br/>

<h2>	Branchial Arch	</h2>
				<img  src="https://vista-enhancer.lbl.gov/structure_gallery/branchial.jpg"/>

			<a className="" href="element?vistaId=hs550"><img className="border mx-2 my-2"src="https://vista-enhancer.lbl.gov/structure_gallery/550_2.jpg"/></a>
            <br/><hr/><br/>


</div>
    );



}